import React from 'react'

class LotNumberItem extends React.PureComponent {
  state = {
    value: null,
  }

  onBlur (e) {
    const value = e.target.value ? parseInt(e.target.value) : ''
    this.props.onChange(value, this.props.placement.id)
    this.setState({ value: null })
  }

  onChange (e) {
    this.setState({ value: e.target.value })
  }

  onKeyPress (e) {
    if (e.key !== 'Enter') return
    e.preventDefault()
    e.stopPropagation()
    e.target.blur()
  }

  className () {
    if (this.props.placement.duplicate) return 'ui index-item error-state'
    return 'ui index-item'
  }

  value () {
    if (this.state.value !== null) return this.state.value
    const { lot_number } = this.props.placement
    if (lot_number === null) return ''
    return lot_number
  }

  name () {
    return `placements[${this.props.placement.id}]`
  }

  render () {
    const { placement } = this.props

    return (
      <div className={this.className()}>
        <a
          className='ui index-item-photo'
          href={placement.link}
          tabIndex='-1'
          style={{
            backgroundImage: `url(${placement.photo})`
          }}
        />

        <div className='ui index-item-rest'>
          <div className='ui index-item-input'>
            <div className='ui input'>
              <input
                value={this.value()}
                name={this.name()}
                onChange={(e) => this.onChange(e)}
                onBlur={(e) => this.onBlur(e)}
                onKeyPress={(e) => this.onKeyPress(e)}
                type='number'
              />
            </div>
          </div>

          <div className='ui index-item-content'>
            <div className='ui index-item-content-title'>
              <span className='dark-gray text'>{placement.item_id}</span>
              <a href={placement.link} title={placement.title} tabIndex='-1'>
                {placement.title}
              </a>
            </div>
            <div className='ui index-item-content-period'>
              {placement.period}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LotNumberItem



// WEBPACK FOOTER //
// ./app/javascript/components/LotNumbers/LotNumberItem.js